import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  TextField,
} from "@mui/material";
import { gameCategories } from "../../util/gameCategories.enum";

const CreateGameModal = ({ open, handleClose, handleSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
  });

  const initialFormData = {
    name: "",
    category: "",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} >
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Create Game</Typography>
          <div>
            <TextField
              id="name"
              label="Name"
              name="name"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.name}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-category-label">Category</InputLabel>
              <Select
                labelId="select-category-label"
                id="category"
                name="category"
                value={formData.category}
                label="Category"
                onChange={handleChange}
              >
                {gameCategories.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateGameModal;
